<div class="container">
    <div class="gauche">
        <div class="titre">Infos pratiques</div>
        <div>
            <picture>
                <source
                type="image/webp"
                srcset="./../../../assets/webp/logo-env-blanc.webp"
                alt="logo"
                >
                <!--fallback---->
                <img src="./../../../assets/logo-env-blanc.png" alt="logo"> contact@sancey-pc.fr
            </picture>
        </div>
        <div>
            <picture>
                <source
                type="image/webp"
                srcset="./../../../assets/webp/logo-tel-blanc.webp"
                alt="logo"
                >
                <!--fallback---->
                <img src="./../../../assets/logo-tel-blanc.png" alt="logo"> 03 86 72 19 95
            </picture>
        </div>
        <div>
            <picture>
                <source
                type="image/webp"
                srcset="./../../../assets/webp/logo-local-blanc.webp"
                alt="logo"
                >
                <!--fallback---->  
                <img src="./../../../assets/logo-local-blanc.png" alt="logo">2 Place Jean Jaurès <br>89000 AUXERRE <br>ou <br>23 Rue Raymond Poincaré <br>10000 TROYES
            </picture>
           </div>
        <div (click)="goFb()">
            <img src="./../../../assets/fb.png" alt="fb">Facebook
        </div>
        <div (click)="goLn()">
            <img src="./../../../assets/ln.png" alt="ln">LinkedIn
        </div>
        <div (click)="goInsta()">
            <img src="./../../../assets/insta.png" alt="insta">Instagram
        </div>
    </div>
    <div class="droite">
        <div class="titre clikable" (click)="nav.nav('contact')">CONSULTER NOS HORAIRES</div>

        <div class="avis">
            <div class="addAvis">
               <a href="https://share.google/5NVYD7OiN2GxFtjDw" target="_blank">Déposez un Avis</a></div>
        </div>
    </div>
</div>